/** Dispatched when persisted Zebra scan state is cleared after reconnect (order no longer delivering). */
export const ZEBRA_ORDER_SCAN_DISCARDED_EVENT = 'helloScreens:zebraOrderScanDiscarded' as const
